import styled from "@emotion/styled";

export const ParallaxWrapperStyled = styled.section`
  scroll-margin: 200px;
`;
